import React from "react"
import { Container, Label, Value } from "./styled"

const PointsView = ({
  className,
  fontColor,
  points,
  pointsSign = "" // Sign as in plus or minus, e.g. "+", "-", or ""
}) => (
  <Container 
    className={className} 
    fontColor={fontColor}
  >
    <Value value={points}>
      { pointsSign.concat(points.toLocaleString()) }
    </Value>
  </Container>
)

export default PointsView

